import { render, staticRenderFns } from "./modal-error.vue?vue&type=template&id=0d7b275a&scoped=true"
import script from "./modal-error.vue?vue&type=script&lang=ts&setup=true"
export * from "./modal-error.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./modal-error.vue?vue&type=style&index=0&id=0d7b275a&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7b275a",
  null
  
)

export default component.exports